import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class WorkshopImportFile extends AdornisFile {
  public static override _class = 'WorkshopImportFile';

  @validate(nonOptional())
  @Field(type => String)
  public institutionID!: string;
}
